import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, vModelCheckbox as _vModelCheckbox, vModelSelect as _vModelSelect, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["onSubmit"]
const _hoisted_2 = { class: "mt-2 border border-gray-400 rounded" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "px-4 py-2 bg-gray-100 border-b border-gray-400" }, "Discount Details", -1)
const _hoisted_4 = { class: "flex" }
const _hoisted_5 = { class: "flex" }
const _hoisted_6 = { class: "flex items-center w-1/2 mt-2 space-x-2" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", null, "Apply to subscription renewals only", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("option", {
  class: "capitalize",
  value: "stripe"
}, "Stripe", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("option", {
  class: "capitalize",
  value: "2checkout",
  selected: ""
}, "2Checkout", -1)
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = { class: "flex" }
const _hoisted_12 = { class: "flex" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "block h-10 px-4 py-2 font-medium text-gray-900 bg-gray-300 border border-gray-400 rounded-r w-1/8" }, "%", -1)
const _hoisted_14 = { class: "flex" }
const _hoisted_15 = ["value"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "block h-10 px-4 py-2 font-medium text-gray-900 bg-gray-300 border border-gray-400 rounded-r w-1/8" }, "%", -1)
const _hoisted_17 = { class: "flex space-x-4" }
const _hoisted_18 = { class: "flex items-center w-1/2 space-x-2" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", null, "Unlimited", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("option", {
  class: "capitalize",
  value: true
}, "Active", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("option", {
  class: "capitalize",
  value: false
}, "Inactive", -1)
const _hoisted_22 = [
  _hoisted_20,
  _hoisted_21
]
const _hoisted_23 = { class: "flex flex-wrap gap-4 py-6" }

import { ref } from "vue";

import DefaultButton from "@/components/DefaultButton.vue";
import ListRowItem from "@/components/ListRowItem.vue";
import TitleHeader from "@/components/TitleHeader.vue";
import RoleGuard from "@/components/RoleGuard.vue";
import TagSelector from "@/components/TagSelector.vue";

import api from "@/api/api";
import { Country, CreateDiscountRequest, Tag } from "@/types";
import { useGlobalStore, useUserStore } from "@/store";
import { formatDate } from "@/utils/dates";
import { userHasRole } from "@/utils/roles";
import { useI18n } from "vue-i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'NewDiscount',
  async setup(__props) {

let __temp: any, __restore: any

const globalStore = useGlobalStore();
const userStore = useUserStore();
const { t: $t } = useI18n();

const isDraftSaving = ref(false);
const isPublishing = ref(false);

const countries = ref([] as Country[]);
const tags = ref([] as Tag[]);

const discount = ref({
  tag_id: "",
  active: false,
  limit: 0,
  name: "",
  code: "",
  percent_amount: 0,
  expires_at: "",
  verifone_product_code: "",
  merchant_name: "stripe",
  renewal_only: false,
} as CreateDiscountRequest);

const datepicker = ref(null);

function setDate(date: Date) {
  if (!date) return;

  discount.value.expires_at = formatDate(date);
  datepicker.value.closeMenu();
}

async function saveDiscount(e: any) {
  try {
    discount.value.active = e.submitter.id;

    if (e.submitter.id) {
      isPublishing.value = true;
    } else {
      isDraftSaving.value = true;
    }

    const response = (await api.discounts.createDiscount(discount.value)).data;

    globalStore.toast("SUCCESS", "Discount created");
    return (window.location.href = `/dashboard/courses/discounts/${response.discount.id}`);
  } catch (e) {
    console.log("ERROR", e);
  } finally {
    isDraftSaving.value = false;
    isPublishing.value = false;
  }
}

if (!userHasRole(userStore.user.roles, ["admin", "courses-admin", "clubs-admin", "users-admin"])) {
  globalStore.toast("ERROR", $t("unauthorized"));
} else {
  countries.value = ((
  ([__temp,__restore] = _withAsyncContext(() => api.misc.listCountries())),
  __temp = await __temp,
  __restore(),
  __temp
)).countries;
  tags.value = ((
  ([__temp,__restore] = _withAsyncContext(() => api.tags.listTags())),
  __temp = await __temp,
  __restore(),
  __temp
)).data.tags;
}

return (_ctx: any,_cache: any) => {
  const _component_DatePicker = _resolveComponent("DatePicker")!

  return (_openBlock(), _createBlock(RoleGuard, { roles: ['admin', 'courses-admin', 'clubs-admin', 'users-admin'] }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(TitleHeader, {
          title: _unref($t)('add-a-new-discount')
        }, null, 8, ["title"])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("form", {
          class: "mt-8",
          onSubmit: _withModifiers(saveDiscount, ["prevent"])
        }, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createVNode(ListRowItem, {
              title: _unref($t)('name')
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    id: "payment",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((discount.value.name) = $event)),
                    class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded",
                    required: ""
                  }, null, 512), [
                    [_vModelText, discount.value.name]
                  ])
                ])
              ]),
              _: 1
            }, 8, ["title"]),
            _createVNode(ListRowItem, {
              title: _unref($t)('code')
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    id: "payment",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((discount.value.code) = $event)),
                    class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded",
                    required: ""
                  }, null, 512), [
                    [_vModelText, discount.value.code]
                  ])
                ])
              ]),
              _: 1
            }, 8, ["title"]),
            _createVNode(ListRowItem, {
              title: _unref($t)('renewal-only')
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((discount.value.renewal_only) = $event)),
                    class: "rounded"
                  }, null, 512), [
                    [_vModelCheckbox, discount.value.renewal_only]
                  ]),
                  _hoisted_7
                ])
              ]),
              _: 1
            }, 8, ["title"]),
            _createVNode(ListRowItem, {
              title: _unref($t)('merchant-name')
            }, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("select", {
                  id: "subscription",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((discount.value.merchant_name) = $event)),
                  class: "capitalize text-black border w-full rounded focus:outline-none focus:shadow-outline-primary font-normal transition duration-50 ease-in px-3 py-1.5 pr-8 h-10 border-gray-600",
                  required: ""
                }, _hoisted_10, 512), [
                  [_vModelSelect, discount.value.merchant_name]
                ])
              ]),
              _: 1
            }, 8, ["title"]),
            (discount.value.merchant_name === '2checkout' && !discount.value.renewal_only)
              ? (_openBlock(), _createBlock(ListRowItem, {
                  key: 0,
                  title: _unref($t)('verifone-product-code')
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_11, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        onkeypress: "return event.which != 32",
                        id: "payment",
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((discount.value.verifone_product_code) = $event)),
                        class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded",
                        required: ""
                      }, null, 512), [
                        [_vModelText, discount.value.verifone_product_code]
                      ])
                    ])
                  ]),
                  _: 1
                }, 8, ["title"]))
              : _createCommentVNode("", true),
            (discount.value.merchant_name === 'stripe')
              ? (_openBlock(), _createBlock(ListRowItem, {
                  key: 1,
                  title: _unref($t)('percent-off')
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_12, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        id: "payment",
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((discount.value.percent_amount) = $event)),
                        class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded-l",
                        required: ""
                      }, null, 512), [
                        [_vModelText, discount.value.percent_amount]
                      ]),
                      _hoisted_13
                    ])
                  ]),
                  _: 1
                }, 8, ["title"]))
              : _createCommentVNode("", true),
            (discount.value.merchant_name === '2checkout')
              ? (_openBlock(), _createBlock(ListRowItem, {
                  key: 2,
                  title: _unref($t)('percent-off')
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_14, [
                      _withDirectives(_createElementVNode("select", {
                        class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded",
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((discount.value.percent_amount) = $event))
                      }, [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (i) => {
                          return _createElementVNode("option", {
                            value: i * 10,
                            key: i
                          }, _toDisplayString(i * 10), 9, _hoisted_15)
                        }), 64))
                      ], 512), [
                        [_vModelSelect, discount.value.percent_amount]
                      ]),
                      _hoisted_16
                    ])
                  ]),
                  _: 1
                }, 8, ["title"]))
              : _createCommentVNode("", true),
            _createVNode(ListRowItem, {
              title: _unref($t)('event-tag')
            }, {
              default: _withCtx(() => [
                _createVNode(TagSelector, {
                  onChange: _cache[7] || (_cache[7] = e => (discount.value.tag_id = e[0])),
                  type: "event",
                  modelValue: discount.value.tag_id,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((discount.value.tag_id) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["title"]),
            _createVNode(ListRowItem, {
              title: _unref($t)('expires-at')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DatePicker, {
                  ref_key: "datepicker",
                  ref: datepicker,
                  onInternalModelChange: _cache[9] || (_cache[9] = e => setDate(e)),
                  required: "",
                  "enable-time-picker": false,
                  format: "dd/MMM/yyyy",
                  class: "mt-1",
                  "min-date": new Date(),
                  modelValue: discount.value.expires_at,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((discount.value.expires_at) = $event))
                }, null, 8, ["min-date", "modelValue"])
              ]),
              _: 1
            }, 8, ["title"]),
            _createVNode(ListRowItem, {
              title: _unref($t)('limit-total-uses')
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_17, [
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    min: "0",
                    step: "1",
                    id: "maxm",
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((discount.value.limit) = $event)),
                    class: "block w-1/2 h-10 py-2 text-gray-900 border border-gray-600 rounded"
                  }, null, 512), [
                    [_vModelText, discount.value.limit]
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      onChange: _cache[12] || (_cache[12] = ($event: any) => (discount.value.limit = 0)),
                      class: "rounded"
                    }, null, 32),
                    _hoisted_19
                  ])
                ])
              ]),
              _: 1
            }, 8, ["title"]),
            _createVNode(ListRowItem, {
              title: _unref($t)('status')
            }, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("select", {
                  id: "subscription",
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((discount.value.active) = $event)),
                  class: "capitalize text-black border w-full rounded focus:outline-none focus:shadow-outline-primary font-normal transition duration-50 ease-in px-3 py-1.5 pr-8 h-10 border-gray-600",
                  required: ""
                }, _hoisted_22, 512), [
                  [_vModelSelect, discount.value.active]
                ])
              ]),
              _: 1
            }, 8, ["title"])
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createVNode(DefaultButton, {
              id: false,
              type: "primary",
              "is-form-submit": true,
              loading: isDraftSaving.value
            }, {
              default: _withCtx(() => [
                _createTextVNode("Save as Draft")
              ]),
              _: 1
            }, 8, ["loading"]),
            _createVNode(DefaultButton, {
              id: true,
              "is-form-submit": true,
              type: "primary",
              loading: isPublishing.value
            }, {
              default: _withCtx(() => [
                _createTextVNode("Publish Discount")
              ]),
              _: 1
            }, 8, ["loading"])
          ])
        ], 40, _hoisted_1)
      ])
    ]),
    _: 1
  }))
}
}

})